// extracted by mini-css-extract-plugin
module.exports = {"partners":"partners_partners__uUzgZ","line":"partners_line__9Na5L","partnersList":"partners_partnersList__QecHq"};